export default __webpack_public_path__ + "5b8e55470caf96cb8453ebd32cbe7afe.svg";